import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper functions
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

export const formatDepartmentRank = (rank: number) => {
	switch (rank) {
		case 0:
			return "Head";
		case 1:
			return "First Deputy";
		case 2:
			return "Second Deputy";
		case 3:
			return "Third Deputy";
		case 4:
			return "Fourth Deputy";
		case 5:
			return "Fifth Deputy";
		default:
			return "--";
	}
};

// ==================== DEPARTMENT COLUMNS ====================
export const departmentColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 200,
		minSize: 150,
		maxSize: 350,
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 380,
		minSize: 250,
		maxSize: 600,
	},
	{
		accessorKey: "code",
		header: "Code",
		size: 180,
		minSize: 120,
		maxSize: 300,
	},
	{
		accessorKey: "active",
		header: "Active",
		size: 140,
		minSize: 100,
		maxSize: 200,
		cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		maxSize: 150,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

// Default column visibility
export const departmentColumnVisibility = {
	name: true,
	description: true,
	code: true,
	active: true,
	createdAt: true,
	modifiedAt: true,
	actions: true,
};
